module.exports = __webpack_public_path__ + "img/singup7.4e1dcdc8.jpg";